"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _popover = _interopRequireDefault(require("antd/lib/popover"));

var _MenuContent = _interopRequireDefault(require("./MenuContent"));

require("./styles.less");

var styles = {
  "popover": "meepshop-meep-ui__submenu-dropdownMenu-styles__popover",
  "groupPopover": "meepshop-meep-ui__submenu-dropdownMenu-styles__groupPopover",
  "menu": "meepshop-meep-ui__submenu-dropdownMenu-styles__menu",
  "menuItem": "meepshop-meep-ui__submenu-dropdownMenu-styles__menuItem",
  "arrow": "meepshop-meep-ui__submenu-dropdownMenu-styles__arrow"
};

/**
 * DropdownMenu
 * 下拉選單：預設，樣式 1
 * @returns {React.ReactElement}
 */
var DropdownMenu = function DropdownMenu(_ref) {
  var pages = _ref.pages,
      renderChildren = _ref.renderChildren,
      onVisibleChange = _ref.onVisibleChange,
      menuSettings = _ref.menuSettings,
      style = _ref.style;
  var children = renderChildren();
  return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    overlayClassName: styles.popover,
    content: /*#__PURE__*/_react["default"].createElement(_MenuContent["default"], {
      pages: pages,
      menuSettings: menuSettings
    }),
    align: {
      offset: [0, 0],
      targetOffset: [0, 0]
    },
    placement: "bottomLeft",
    onVisibleChange: onVisibleChange
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: style
  }, children));
};

var _default = DropdownMenu;
exports["default"] = _default;